import { MediaResolver, ResolvedMedia, ResolverContext } from '../types';
import { isImageContentType } from '../utils/contentType';

export class UnknownResolver implements MediaResolver {
  name = 'UnknownResolver';

  async canResolve(_context: ResolverContext): Promise<boolean> {
    return true;
  }

  async resolve(context: ResolverContext): Promise<ResolvedMedia | null> {
    const { url, thumbnailUrl, title, description } = context.input;

    try {
      const content = await context.fetchContent(url);

      if (isImageContentType(content.contentType)) {
        return {
          mediaType: 'image',
          playerType: 'html5',
          playbackUrl: content.finalUrl,
          thumbnailUrl: content.finalUrl,
          title: title ?? undefined,
          description: description ?? undefined,
          resolved: true,
          resolverName: this.name,
          metadata: {
            strategy: 'content-type-image',
          },
        };
      }
    } catch {
      // fall through to unresolved response
    }

    return {
      mediaType: thumbnailUrl ? 'video' : 'image',
      playerType: 'html5',
      thumbnailUrl: thumbnailUrl ?? undefined,
      title: title ?? undefined,
      description: description ?? undefined,
      resolved: false,
      resolverName: this.name,
      metadata: {
        sourceUrl: url,
      },
    };
  }
}
